export default __webpack_public_path__ + "static/media/menu-button.d925bad3.svg";